import React, { Fragment, useState, useEffect, useRef } from "react";
import { CommonSvg } from "../SVG";

export const ArrowDropDownSvgIconComponent = ({ ISACTIVE = true }) => {
  return (
    <svg
      width="8"
      height="5"
      viewBox="0 0 8 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.37788 4.025L1.15288 1.775C0.869551 1.49167 0.802885 1.16667 0.952885 0.8C1.10288 0.433334 1.38622 0.25 1.80289 0.25H6.22789C6.62789 0.25 6.90689 0.433334 7.06489 0.8C7.22355 1.16667 7.16122 1.49167 6.87788 1.775L4.65288 4.025C4.55288 4.10833 4.45289 4.175 4.35289 4.225C4.25289 4.275 4.13622 4.3 4.00288 4.3C3.88622 4.3 3.77788 4.275 3.67789 4.225C3.57789 4.175 3.47788 4.10833 3.37788 4.025Z"
        fill={ISACTIVE ? "#F6F6F6" : "#1E293B"}
      />
    </svg>
  );
};

const orientation = [
  { id: "Landscape", title: "Landscape", label: "Landscape" },
  { id: "Portrait", title: "Portrait", label: "Portrait" },
  { id: "Square", title: "Square", label: "Square" },
];

const CommonFilter = ({
  isSelected = false,
  Type = "Orientation",
  Title = "Orientation",
  filterLableData = orientation,
  state,
  selectedState,
  Width = "max-content",
  isCircledFilter = false,
  isSubFilter = false,
  isCheckSingular = false,
  isSingular = false,
  isAssets = false,
  isCustomDate = false,
}) => {
  const [isActive, setIsActive] = useState(false);
  const [isExtension, setIsExtension] = useState(false);
  const [inputSearch, setInputSearch] = useState();
  const [subfolderData, setSubFolderData] = useState();

  // 👇 ref for detecting clicks outside
  const dropdownRef = useRef(null);
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsActive(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const circleDesignFilter = () => {
    return (
      <div
        className="dis_grid grid_cols_3 gap-4 p-2 threedotsiconclickfunction2nd"
        style={{
          width: Width,
          minWidth:"min-content"
        }}
      >
        {filterLableData?.map((item, index) => (
          <div
            key={index}
            style={{
              color: "black",
              alignItems: "center",
              cursor: "pointer",
            }}
            className="d-flex items-center gap-2"
            onClick={() => {
              const checked = state?.[Title]?.includes(item.label);
              selectedState((prev) => {
                const currentValues = prev[Title] || [];

                if (!checked) {
                  return {
                    ...prev,
                    [Title]: isAssets
                      ? [item.label]
                      : [...currentValues, item.label],
                  };
                } else {
                  return {
                    ...prev,
                    [Title]: currentValues.filter((val) => val !== item.label),
                  };
                }
              });
            }}
          >
            <div
              className={`backbody ${
                state?.[Title]?.includes(item?.label) ? "backbody_selected" : ""
              }`}
            >
              {isAssets ? (
                <div
                  className={`backbody ${
                    state?.[Title]?.includes(item?.label) && "backbody_selected"
                  }`}
                >
                  {item?.asset}
                </div>
              ) : (
                <div
                  className="circle"
                  style={{
                    backgroundColor: item?.key,
                  }}
                ></div>
              )}
            </div>
            <div>{item?.key}</div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <Fragment>
      <div className="position_relative" ref={dropdownRef}>
        <div
          className={`entities_dropdown_desing gap-2 ${
            (isSelected || isActive) && "selected_color_design"
          } position_relative`}
          onClick={() => setIsActive(!isActive)}
        >
          {Title}{" "}
          <ArrowDropDownSvgIconComponent ISACTIVE={isSelected || isActive} />
        </div>

        {isActive &&
          (isSubFilter ? (
            <div
              className="position_absolute threedotsiconclickfunction2nd"
              style={{
                width: Width,
              }}
            >
              <div className="dis_grid gap-2 p-2">
                <div className="dis_grid  gap-2">
                  <div style={{ color: "black" }}>
                    <div className="d-flex align-items-center gap-2 filter_padding_desing">
                      <div>
                        <input
                          type="checkbox"
                          className="w_h_18p"
                          checked={state?.isExtension || false}
                          onChange={(e) => {
                            selectedState((prev) => ({
                              ...prev,
                              isExtension: e.target.checked,
                              [Title]: {},
                            }));
                          }}
                        />
                      </div>
                      <div className="task_history_header_desing_2 sub_head_design">
                        Search By Extension
                      </div>
                    </div>
                  </div>
                </div>

                {state?.isExtension && (
                  <div
                    className="d-flex search-box align-items-center"
                    style={{
                      width: "200px",
                    }}
                  >
                    <div
                      style={{
                        marginLeft: "0.5rem",
                      }}
                    >
                      {CommonSvg.searchIconSvg}
                    </div>
                    <input
                      type="search"
                      placeholder="Search Extension"
                      value={state?.searchInput || ""}
                      onChange={(e) => {
                        selectedState((prev) => ({
                          ...prev,
                          searchInput: e.target.value,
                        }));
                      }}
                    />
                  </div>
                )}

                <div
                  className={`d-flex gap-2 ${
                    isExtension && "hide_pointers"
                  } display_block_assigner`}
                >
                  <div
                    className="dis_grid gap-2"
                    style={{
                      borderRight: "1px solid #E6E6E6",
                      paddingRight: "1rem",
                      height: "fit-content",
                    }}
                  >
                    {filterLableData?.map((item, index) => (
                      <div
                        className="d-flex align-items-center gap-2 filter_padding_desing justify-content-between"
                        key={index}
                      >
                        <div className="d-flex align-items-center gap-2">
                          <div>
                            <input
                              type="checkbox"
                              className="w_h_18p"
                              checked={state?.[Title]?.hasOwnProperty(
                                item.type
                              )}
                              onChange={(e) => {
                                const checked = e.target.checked;
                                selectedState((prev) => {
                                  const currentValues = {
                                    ...(prev[Title] || {}),
                                  };

                                  if (checked) {
                                    currentValues[item.type] = [];
                                  } else {
                                    delete currentValues[item.type];
                                  }

                                  return {
                                    ...prev,
                                    [Title]: currentValues,
                                  };
                                });
                              }}
                              disabled={state?.isExtension}
                            />
                          </div>
                          <div className="task_history_header_desing_2 sub_head_design">
                            {item?.type}
                          </div>
                        </div>
                        <div
                          className={`arrow_Icon_svg`}
                          style={{ marginLeft: "5rem" }}
                          onClick={() => setSubFolderData(item)}
                        >
                          {CommonSvg.rightArrowSvgIcon}
                        </div>
                      </div>
                    ))}
                  </div>

                  <div
                    style={{
                      maxHeight: "200px",
                      overflow: "auto",
                      padding: "0.5rem",
                      paddingRight: "10rem",
                      height: "fit-content",
                    }}
                    className="dis_grid gap-2"
                  >
                    {subfolderData?.extensions?.map((item, index) => (
                      <div
                        className="d-flex align-items-center gap-2 filter_padding_desing"
                        key={index}
                      >
                        <div>
                          <input
                            type="checkbox"
                            className="w_h_18p"
                            checked={state?.[Title]?.[
                              subfolderData?.type
                            ]?.includes(item)}
                            onChange={(e) => {
                              const checked = e.target.checked;

                              selectedState((prev) => {
                                const currentValues = prev[Title] || {};
                                const existingArray =
                                  currentValues[subfolderData.type] || [];

                                let reflectedObj;

                                if (checked) {
                                  reflectedObj = {
                                    ...currentValues,
                                    [subfolderData.type]: [
                                      ...existingArray,
                                      item,
                                    ],
                                  };
                                } else {
                                  reflectedObj = {
                                    ...currentValues,
                                    [subfolderData.type]: existingArray.filter(
                                      (data) => data !== item
                                    ),
                                  };
                                }

                                return {
                                  ...prev,
                                  [Title]: reflectedObj,
                                };
                              });
                            }}
                          />
                        </div>
                        <div className="task_history_header_desing_2 sub_head_design">
                          {item}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ) : isCircledFilter ? (
            circleDesignFilter()
          ) : (
            <div className="position_absolute threedotsiconclickfunction2nd">
              <div>
                {filterLableData?.map((item) => (
                  <div
                    className="d-flex align-items-center gap-2 filter_padding_desing"
                    key={item?.id}
                  >
                    <div>
                      <input
                        type="checkbox"
                        className="w_h_18p"
                        checked={state?.[Title]?.includes(item.id) || false}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          selectedState((prev) => {
                            const currentValues = prev[Title] || [];

                            if (checked) {
                              return {
                                ...prev,
                                [Title]: isCheckSingular
                                  ? [item.id]
                                  : [...currentValues, item.id],
                              };
                            } else {
                              return {
                                ...prev,
                                [Title]: currentValues.filter(
                                  (val) => val !== item.id
                                ),
                              };
                            }
                          });
                        }}
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                    <div className="task_history_header_desing_2 sub_head_design">
                      {item?.label}
                    </div>
                  </div>
                ))}

                {isCustomDate && (
                  <div
                    className="d-flex align-items-center gap-2 filter_padding_desing"
                    key={"item?.id"}
                  >
                    <div>
                      <input
                        type="checkbox"
                        className="w_h_18p"
                        checked={state.isCustomData}
                        onChange={(e) => {
                          selectedState((prev) => ({
                            ...prev,
                            isCustomData: e.target.checked,
                          }));
                        }}
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                    <div className="task_history_header_desing_2 sub_head_design">
                      Custom
                    </div>
                  </div>
                )}
                {state?.isCustomData && isCustomDate && (
                  <div>
                    <div className="gap-2">
                      <div className="d-flex gap-2 align-items-center m-2">
                        <label>Start Date</label>
                        <input
                          type="date"
                          className="dateinput p-2"
                          onChange={(e) => {
                            selectedState((prev) => ({
                              ...prev,
                              startDate: e.target.value,
                            }));
                          }}
                        />
                      </div>
                      <div className="d-flex gap-2 align-items-center m-2">
                        <label>End Date</label>
                        <input
                          type="date"
                          className="dateinput p-2"
                          onChange={(e) => {
                            selectedState((prev) => ({
                              ...prev,
                              endDate: e.target.value,
                            }));
                          }}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
      </div>
    </Fragment>
  );
};

export default CommonFilter;
